import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: CheckboxComponent,
      multi: true
    }
  ]
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input()
  set checked(checked: boolean) {
    this.checkedValue = checked;
  }

  get checked(): boolean {
    return this.checkedValue;
  }

  @Input() formControl: FormControl;
  @Input() isDisabled: boolean;
  @Input() readonly: boolean;

  @Input() showValidations = false;

  @Output() checkedChange = new EventEmitter<boolean>();

  private checkedValue: boolean;

  private onChangeCallback: (_: any) => {};
  private onTouchedCallback: (_: any) => {};

  constructor() {
  }

  onChange(change: MatCheckboxChange) {
    this.checked = change.checked;
    if (this.onChangeCallback) {
      this.onChangeCallback(this.checked);
    }
    if (this.onTouchedCallback) {
      this.onTouchedCallback(this.checked);
    }
    this.checkedChange.emit(this.checked);
  }

  writeValue(checked: boolean): void {
    this.checked = checked;
  }

  registerOnChange(fn): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn): void {
    this.onTouchedCallback = fn;
  }

  get showErrors() {
    return this.showValidations || (this.formControl?.invalid && this.formControl?.touched);
  }
}
